import { AuthMethod } from '../common/v1/types_pb';

export const formatAuthMethod = (authMethod: AuthMethod, venueAccessCode?: string): string => {
  switch (authMethod) {
    case AuthMethod.MOBILE_PIN:
      return 'Mobile PIN';
    case AuthMethod.MOBILE_EXPRESS:
      return 'Express';
    case AuthMethod.VENUE_ACCESS_CODE:
      return venueAccessCode ? `Venue Code (${venueAccessCode})` : 'Venue Code';
    case AuthMethod.UNSPECIFIED:
    default:
      return 'Unknown';
  }
};